import OutlinedFlagIcon from '@mui/icons-material/OutlinedFlag';
import { Chip, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useIsConvelioSupplier } from 'src/app/hooks/useIsConvelioSupplier';
import { translations } from 'src/locales/translations';

type Props = {
  deliveryDate?: string | null;
};

/**
 * Amber "Deadline shipment" chip surfaced on a booking when its linked
 * Salesforce order has a delivery deadline. Internal Convelio supplier teams
 * (Le Bourget / Heathrow) only.
 */
export const FinalDeliveryFlag = ({
  deliveryDate
}: Props): JSX.Element | null => {
  const { t } = useTranslation();
  const isConvelioSupplier = useIsConvelioSupplier();

  if (!isConvelioSupplier || !deliveryDate) {
    return null;
  }

  return (
    <FinalDeliveryChipStyled
      data-testid="final-delivery-flag"
      icon={<OutlinedFlagIcon />}
      label={t(translations.finalDelivery)}
    />
  );
};

const FinalDeliveryChipStyled = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.warning.light,
  color: theme.palette.warning.dark,
  marginLeft: 4,
  paddingX: 8,
  paddingY: 4,
  fontSize: '0.8rem',
  lineHeight: '1.09rem',
  fontWeight: 600,
  height: 24,
  '& .MuiChip-icon': {
    color: theme.palette.warning.dark
  }
}));
